<div #switcherBox class="switcher-box" [class.switcher-box--dynamic]="isDynamicWidth">
    <span #switcherState class="switcher-box__state"></span>
    @for (config of switcherConfig; let idx = $index; track idx) {
        <button
            #index
            class="switcher-box__btn"
            [class.active]="idx === selectedIndex"
            (click)="selectSwitch(index, config.parameter, idx)"
        >
            {{ config.label }}

          @if(config?.info?.count) {
            <span class="switcher-box__count" [ngClass]="{
              'switcher-box__count--circle': config?.info?.type === 'circle',
              'switcher-box__count--hurt': config?.info?.type === 'hurt'
            }">
              {{config.info.count}}
            </span>
          }
        </button>
    }
</div>
